module.exports = __webpack_public_path__ + "assets/retina_OctagonBySideDetailed.04dfe5a7c4cc65bc3daf98d9013d7066.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_OctagonBySideDetailed.png
// module id = 695
// module chunks = 0